export default __webpack_public_path__ + "static/media/misc-makeupA-768w.be614fdc.avif";